import { schema } from 'normalizr'

import takeoutMenuPage from './takeoutMenuPage'

const tableMenu = new schema.Entity('takeoutMenus', {
  takeout_menu_pages: [takeoutMenuPage],
})

export default tableMenu
